const natureOfBusOptions = {
  AG01: 'AG   FRUIT PRODUCE PROCESSOR',
  AG02: 'AG   HORSE BOARDING   ANIMAL BOARDING',
  AG03: 'AG   PRODUCE STAND',
  AG04: 'AG  AGRICULTURAL PRODUCTION',
  IND01: 'AIRCRAFT PARTS',
  APT01: 'APARTMENTS',
  AUT01: 'AUTO   BUS SERVICES',
  AUT05: 'AUTO   DEALERSHIP',
  AUT11: 'AUTO   DETAILING',
  AUT02: 'AUTO   DRIVING SCHOOL',
  AUT10: 'AUTO   GLASS',
  AUT03: 'AUTO   LUBE OIL FILTER',
  AUT06: 'AUTO   MECHANIC REPAIR SHOP',
  AUT07: 'AUTO   MOTORCYCLE DEALERSHIP',
  AUT04: 'AUTO   TOWING',
  BANK01: 'BANK   CREDIT UNION',
  BANK02: 'BANK   FINANCIAL',
  BILLB: 'BILLBOARDS',
  BOREN: 'BOOTH RENTAL',
  TRAD01: 'CABINETRY',
  AUT08: 'CAR WASH AUTOMATIC ',
  AUT09: 'CAR WASH MANUEL',
  CET01: 'CELL TOWER FIBER OPTIC',
  CEM02: 'CEMETERY',
  CENA1: 'CENTRAL ASSESSED',
  COMP1: 'COMPUTER CONSULTING   SUPPORT',
  COMP2: 'COMPUTER DESIGN',
  COMP3: 'COMPUTER REPAIR',
  COMP4: 'COMPUTER SOFTWARE',
  CNDA1: 'CONDO ASSOCIATIONS',
  TRAD02: 'CONSTRUCTION',
  TRAD03: 'CONTRACTOR',
  IND02: 'CRANE SERVICE',
  DANC1: 'DANCE STUDIO',
  DATA1: 'DATA PROCESSING',
  DAYC1: 'DAYCARE',
  DIGTV1: 'DIGITAL SATTELITE TV INSTALL',
  DIGTV2: 'DIGITAL SATTELITE TV PROVIDER',
  DIST1: 'DISTRIBUTION',
  DRYC1: 'DRY CLEANING',
  IND03: 'ELECTRICIANS',
  ENT01: 'ENTERTAINMENT VENUES',
  EVEE01: 'EVENTS   PLANNING   VENUE',
  IND04: 'EXCAVATING',
  EXMP2: 'EXEMPT   CHARITY',
  EXMP1: 'EXEMPT   EDUCATIONAL',
  EXMP3: 'EXEMPT   GOVERNMENT',
  EXMP4: 'EXEMPT   RELIGIOUS',
  FILM1: 'FILM   PRODUCTION   DIRECTING',
  FWST1: 'FIREWORKS STAND',
  FISH01: 'FISHERIES',
  GYM01: 'FITNESS  GYM ORANGE THEORY',
  GYM02: 'FITNESS  VASA',
  FOUN1: 'FOUNDATIONS ORGANIZATIONS',
  FOUN2: 'FOUNDRY',
  GLFC1: 'GOLF CLUB   PRIVATE',
  GRHS1: 'GREENHOUSES',
  GRM01: 'GROOMING ANIMAL',
  GRPH1: 'GROUP CARE HOME',
  GUNS01: 'GUNSMITH',
  HAND1: 'HANDYMAN',
  HOBA01: 'HOME BASED OFFICE',
  HOBA02: 'HOME BASED RETAIL',
  HOBA03: 'HOME BASED TRADES',
  HOS01: 'HOSPITAL',
  HOT01: 'HOTEL ',
  INDW1: 'INDUSTRIAL WAREHOUSE',
  LANDL: 'LANDLORD',
  LANDS: 'LANDSCAPING SERVICES',
  SERV19: 'LAUNDRY   LAUNDRYMAT',
  LEASE: 'LEASES',
  LOCK1: 'LOCKSMITH',
  MACH: 'MACHINE SHOP FABRICATION',
  MAINT: 'MAINTENANCE AIR CRAFT',
  MANU: 'MANUFACTURING',
  MARI: 'MARINA',
  SERV21: 'MASSAGE THERAPY',
  METPR: 'MEAT PROCESSING',
  MOB01: 'MOBILE   AUTO REPAIR',
  MOB09: 'MOBILE   ENTERTAINMENT',
  MOB02: 'MOBILE   FOOD TRUCK',
  MOB03: 'MOBILE   FOOD/COOKING NON FOOD TRUCK',
  MOB04: 'MOBILE   HOME PARKS',
  MOB05: 'MOBILE   LANDSCAPING',
  MOB06: 'MOBILE   MEDICAL',
  MOB07: 'MOBILE   REPAIR',
  MOB08: 'MOBILE   SALES',
  MODHO: 'MODEL HOME',
  MORT01: 'MORTUARY FUNERAL HOME',
  MOTE1: 'MOTEL',
  THEA1: 'MOVIE THEATER',
  MUS01: 'MUSIC',
  NEWS1: 'NEWSPAPER',
  NURH1: 'NURSING HOME',
  OFF01: 'OFFICE',
  OFF02: 'OFFICE   ATTORNEY',
  OFF20: 'OFFICE   CHIROPRACTOR',
  OFF03: 'OFFICE   CPA',
  OFF04: 'OFFICE   DENTAL',
  OFF05: 'OFFICE   DENTAL LAB',
  OFF06: 'OFFICE   HOLDING   NAME ONLY $0.00',
  OFF07: 'OFFICE   INSURANCE ',
  OFF08: 'OFFICE   INSURANCE TITLE',
  OFF09: 'OFFICE   MARKETING',
  OFF10: 'OFFICE   MEDICAL ',
  OFF11: 'OFFICE   MEDICAL  EYE',
  OFF12: 'OFFICE   MEDICAL LAB',
  OFF13: 'OFFICE   MEDICAL PEDIATRICS',
  OFF14: 'OFFICE   MORTGAGE',
  OFF15: 'OFFICE   PAY DAY LOANS',
  OFF16: 'OFFICE   PHYSICIANS',
  OFF19: 'OFFICE   PROPERTY MANAGER',
  OFF17: 'OFFICE   REAL ESTATE',
  OFF18: 'OFFICE   RENTAL MANAGEMENT ',
  OILF01: 'OIL FIELDS',
  PHON1: 'PHONE',
  PRINT1: 'PRINT SHOPS',
  PUBLI1: 'PUBLISHING   DISTRIBUTING   MEDIA',
  RECRE: 'RECREATION',
  REHB1: 'REHAB INPATIENT FACILITY',
  REHB2: 'REHAB OUTPATIENT FACILITY',
  EQURE: 'RENTAL   EQUIPMENT',
  SKIRE: 'RENTAL   SKI',
  REST03: 'RESTAURANT BAKERY',
  REST04: 'RESTAURANT COFFEE & JUICE SHOPS',
  REST05: 'RESTAURANT FAST CASUAL DINING ',
  REST01: 'RESTAURANT FAST FOOD',
  REST02: 'RESTAURANT FULL SERVICE',
  REST06: 'RESTAURANT MOM & POPS TYPE',
  RET01: 'RETAIL',
  RET03: 'RETAIL   ALARM SYSTEMS',
  RET02: 'RETAIL   AUTHORS   ARTISTS',
  RET04: 'RETAIL   AUTO PARTS',
  RET06: 'RETAIL   BAR',
  RET07: 'RETAIL   BOUTIQUE',
  RET08: 'RETAIL   BRIDAL ',
  RET09: 'RETAIL   C STORE',
  RET10: 'RETAIL   C STORE WITH FAST FOOD',
  RET11: 'RETAIL   CAR RENTALS',
  RET31: 'RETAIL   CLOTHING',
  RET12: 'RETAIL   CRAFT',
  RET13: 'RETAIL   EQUIPMENT',
  RET32: 'RETAIL   FLOORING',
  RET14: 'RETAIL   FLORAL',
  RET30: 'RETAIL   GROCERY STORE',
  RET15: 'RETAIL   HOME FURNISHINGS',
  RET16: 'RETAIL   INTERNET SALES',
  RET25: 'RETAIL   JEWELRY, TROPHIES',
  RET17: 'RETAIL   KIOSK',
  RET28: 'RETAIL   LARGE STORES ',
  RET18: 'RETAIL   NEIGHBORHOOD SHOPPING CENTER',
  RET26: 'RETAIL   NURSERYS GARDEN SHOPS',
  RET19: 'RETAIL   ONLINE',
  RET20: 'RETAIL   PHARMACY',
  RET29: 'RETAIL   SM MED STORES ',
  RET27: 'RETAIL   THRIFT STORE',
  RET22: 'RETAIL   TIRES',
  RET23: 'RETAIL   TRAILER SALES',
  RET24: 'RETAIL   WHOLESALE',
  SCH01: 'SCHOOL   COLLEGE  TECHNOLOGY',
  SCH02: 'SCHOOL   COSMETOLOGY',
  SCH03: 'SCHOOL   DANCE ACADEMY',
  SCH04: 'SCHOOL   DISTRICT',
  SCH05: 'SCHOOL   ELEM',
  SCH06: 'SCHOOL   PRE SCHOOL',
  SERV01: 'SERVICES   ACCOUNTING',
  SERV02: 'SERVICES   ADOPTIONS',
  SERV03: 'SERVICES   ADVERTISING',
  SERV04: 'SERVICES   AMBULANCE',
  SERV05: 'SERVICES   BARBER SHOP',
  SERV06: 'SERVICES   BEAUTY SALON BOOTH RENTAL',
  SERV07: 'SERVICES   BEAUTY SALON OWNER',
  SERV08: 'SERVICES   BUSINESS',
  SERV09: 'SERVICES   CLEANING',
  SERV11: 'SERVICES   COMMERCIAL JANITORIAL',
  SERV12: 'SERVICES   CONSULTING',
  SERV13: 'SERVICES   COUNSELING',
  SERV14: 'SERVICES   FOOD PREPARATION CATERING',
  SERV15: 'SERVICES   HOME DECOR',
  SERV16: 'SERVICES   HVAC',
  SERV17: 'SERVICES   INTERIOR DESIGN',
  SERV18: 'SERVICES   INTERNET',
  SERV20: 'SERVICES   MARTIAL ARTS',
  SERV22: 'SERVICES   PAINTING  ',
  SERV23: 'SERVICES   PEST CONTROL   SMALL ',
  SERV28: 'SERVICES   PHOTOGRAPHY',
  SERV24: 'SERVICES   PHOTOPROCESSING',
  SERV25: 'SERVICES   PIANO TEACHER',
  SERV29: 'SERVICES   PLUMBING ',
  SERV26: 'SERVICES   REPAIR',
  SERV30: 'SERVICES   REPAIR  LAWN MOWER',
  SERV27: 'SERVICES   SHUTTLE',
  SERV31: 'SERVICES   SOLAR INSTALATION',
  SERV35: 'SERVICES   SOLAR SALES',
  SERV32: 'SERVICES   SPA AND SALON',
  SERV36: 'SERVICES   TUTORING',
  SERV33: 'SERVICES   VENDING',
  SERV34: 'SERVICES   WATER DELIVERY SERVICES',
  SHIP1: 'SHIPPING  TRANSPORTATION   MAILINGS',
  SHTR1: 'SHOOTING RANGES',
  RESSK1: 'SKI RESORT',
  SNOSH: 'SNOWSHACKS',
  STORU: 'STORAGE UNITS',
  TAXID: 'TAXIDERMY',
  TELEC: 'TELECOMMUNICATIONS   LINES   POLES',
  TREES: 'TREES   CHRISTMAS TREES',
  TRCK1: 'TRUCKING',
  UNKNO: "UNKNOWN   CAN'T FIND   UNDETERMINED",
  VETER: 'VETERINARIAN ANIMAL HOSPITAL',
  WAREH: 'WAREHOUSE',
  WASMA: 'WASTE MANAGEMENT',
  PETRO: 'WHOLESALE PETROLEUM',
  WRKYD: 'WRECKING YARD',
};

export default natureOfBusOptions;
